import { render, staticRenderFns } from "./general-form.vue?vue&type=template&id=644608ec&scoped=true&"
import script from "./general-form.vue?vue&type=script&lang=js&"
export * from "./general-form.vue?vue&type=script&lang=js&"
import style0 from "./general-form.vue?vue&type=style&index=0&id=644608ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644608ec",
  null
  
)

export default component.exports